// Ozlo Ticker Animation
// Extracted from ozlo-main.js
// Animated scrolling ticker with dynamic duration

function initTicker() {
  const tickers = document.querySelectorAll('.ticker-wrapper');

  if (tickers.length === 0) return;

  // Calculate and set ticker container height
  const updateTickerHeight = () => {
    const tickerContainer = document.querySelector('.ticker-container');
    if (tickerContainer) {
      const height = tickerContainer.offsetHeight;
      document.documentElement.style.setProperty('--ticker-height', `${height}px`);
    }
  };

  // Calculate animation duration based on content width
  const setTickerDuration = (ticker) => {
    // Formula: (scrollWidth + parentWidth) / 60 seconds
    const duration = (ticker.scrollWidth + ticker.parentElement.offsetWidth) / 60;
    ticker.style.animationDuration = `${duration}s`;
  };

  // Initialize all tickers
  tickers.forEach(ticker => {
    setTickerDuration(ticker);
  });

  updateTickerHeight();

  // Update on window resize
  window.addEventListener('resize', () => {
    tickers.forEach(ticker => {
      setTickerDuration(ticker);
    });
    updateTickerHeight();
  });

  // Pause/resume animation based on page visibility
  document.addEventListener('visibilitychange', () => {
    tickers.forEach(ticker => {
      ticker.style.animationPlayState = document.hidden ? 'paused' : 'running';
    });
  });
}

// Initialize on page load
window.addEventListener('load', initTicker);
